import axios from 'axios';
import moment from 'moment';
import { mapState } from 'vuex';
import { db } from '@/db';
import { cloudFunctions } from '../config';

export default {
  name: 'match-player-trainer-mixin',

  data() {
    return {
      teams: [],
      team_infos: false,
      bottomSheet: 'hidden',
      stackAnimation: {
        classes: 'zoomIn',
        delay: 300,
        duration: 400,
      },
      overlay: null,
      clientY: 0,
    };
  },

  computed: {
    ...mapState(['user_data', 'visibleCards', 'loading', 'payments']),

    unlimitedPackageIsActive() {
      return (
        this.payments && this.payments.length && this.payments[0].plan_details.id === 5
      );
    },

    unlimitedPackageIsValid() {
      if (
        this.payments &&
        this.payments.length &&
        this.payments[0].plan_details.id === 5
      ) {
        return moment().diff(moment(this.payments[0].timestamp, 'x'), 'days') <= 365;
      }
      return true;
    },

    unlimitedPackageValidDays() {
      if (
        this.payments &&
        this.payments.length &&
        this.payments[0].plan_details.id === 5
      ) {
        return 365 - moment().diff(moment(this.payments[0].timestamp, 'x'), 'days');
      }
      return 365;
    },

    key() {
      return `swiped-${this.user_data.id}`;
    },
  },

  watch: {
    'user_data.swipesLeft': {
      handler(newVal) {
        if (
          (this.user_data.userType === 'player' ||
            this.user_data.userType === 'trainer') &&
          newVal === 0
        ) {
          const collection =
            this.user_data.userType === 'player' ? 'users' : 'trainers';

          this.$store.state.buy_swipes_dialog = true;
          this.user_data.swipesUsedAt = Date.now();

          db.collection(collection).doc(this.user_data.id).update({
            swipesUsedAt: this.user_data.swipesUsedAt,
          });
        }

        // todo: by login/autologin in app.vue check this date and add 5 free swipes after 7 days
      },
    },
  },

  firestore: {
    teams: db.collection('teams'),
  },

  methods: {
    async sendPushMessage(recieverCollection, recieverId) {
      const recieverData = await db
        .collection(recieverCollection)
        .doc(recieverId)
        .get()
        .then((snapshot) => snapshot.data());

      // send email if allowed or if user didn't login after feature deployed and it's should be default true
      if (
        recieverData.messagingEmailConnection ||
        recieverData.messagingEmailConnection === undefined
      ) {
        axios({
          method: 'post',
          url: `${cloudFunctions}/sendNotificationEmail`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data: {
            email: recieverData.email,
            name: recieverData.name,
            type: 'connection',
            senderType: this.user_data.userType,
          },
        });
      }

      if (
        recieverData.messagingToken &&
        recieverData.messagingPush &&
        recieverData.messagingPushConnection
      ) {
        console.log('PUSH: messaging token exists: ', recieverData.messagingToken);
        axios({
          method: 'post',
          url: `${cloudFunctions}/sendPushMessage`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data: {
            data: {
              title: 'Neue Connect-Anfrage',
              body: '⚽️ Glückwunsch, du hast eine neue Connect-Anfrage! ✅',
              longTitle: 'Neue Connect-Anfrage',
              longText:
                '⚽️ Match? Du hast eine neue Connect-Anfrage! ✅ Gehe jetzt in deinen Account, um die offene Connect-Anfrage zu prüfen. 📲',
              icon: 'https://www.chance4talents.app/img/icons/android-chrome-192x192.png',
            },
            token: recieverData.messagingToken,
          },
        });
      }

      // if (
      //   recieverData.safariToken &&
      //   recieverData.messagingPush &&
      //   recieverData.messagingPushConnection
      // ) {
      //   console.log('PUSH: safari token exists: ', recieverData.safariToken);
      //   axios({
      //     method: 'post',
      //     url: `${cloudFunctions}/sendNotificationSafari`,
      //     headers: {
      //       'content-type': 'application/json',
      //       'Access-Control-Allow-Origin': '*',
      //     },
      //     data: {
      //       type: 'connection',
      //       deviceId: recieverData.safariToken,
      //     },
      //   });
      // }
    },

    disableRubberBand(event) {
      const clientY = event.targetTouches[0].clientY - this.clientY;

      if (this.overlay.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }

      if (this.isOverlayTotallyScrolled() && clientY < 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }
    },

    isOverlayTotallyScrolled() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
      return (
        this.overlay.scrollHeight - this.overlay.scrollTop <= this.overlay.clientHeight
      );
    },

    userSwiped(id) {
      let savedSwipes = localStorage.getItem(this.key)
        ? JSON.parse(localStorage.getItem(this.key))
        : [];
      savedSwipes = [...savedSwipes, { id, swipedAt: Date.now() }];

      localStorage.setItem(this.key, JSON.stringify(savedSwipes));
    },

    getActiveTeamIds(beforeDays) {
      const activateAfterTimePoint = Date.now() - beforeDays * 24 * 60 * 60 * 1000;
      const savedSwipes = localStorage.getItem(this.key)
        ? JSON.parse(localStorage.getItem(this.key))
        : [];

      console.log({ savedSwipes });
      return savedSwipes
        .filter((swipe) => swipe.swipedAt > activateAfterTimePoint)
        .map((swiped) => swiped.id);
    },

    handleCardAccepted(id) {
      this.userSwiped(id);
      this.applyForTeam(id);
    },

    handleCardSkipped() {
      console.log('card skipped, do nothing');
    },

    removeCardFromDeck() {
      this.$store.state.visibleCards.pop();
    },

    handleCardRejected(id, collection) {
      this.userSwiped(id);
      this.user_data.swipesLeft = this.user_data.swipesLeft - 1;

      db.collection(collection).doc(this.user_data.id).update({
        swipesLeft: this.user_data.swipesLeft,
      });
    },
  },
};
